import { r as l, c as s, h as o, H as n, g as c } from "./main-bb89b2f2.js";
import "vue";
const d = "*,:after,:before{border-color:var(--color-neutral-steel-200);border-style:solid;border-width:0;box-sizing:border-box}a{color:inherit;text-decoration:inherit}audio,canvas,embed,iframe,img,object,svg,video{display:block;vertical-align:middle}button,input,optgroup,select,textarea{font-feature-settings:inherit;color:inherit;font-family:inherit;font-size:100%;font-variation-settings:inherit;font-weight:inherit;letter-spacing:inherit;line-height:inherit;margin:0;padding:0}blockquote,dd,dl,fieldset,figure,h1,h2,h3,h4,h5,h6,hr,p,pre{margin:0}fieldset,legend{padding:0}.ml-0{margin-left:var(--spacing-0)}.block{display:block}.flex{display:flex}.uppercase{text-transform:uppercase}.capitalize{text-transform:capitalize}.outline{outline-style:solid}:host{display:block}:host(.ml-0)>div{margin-left:0}.tab{display:flex;margin:8px}.tab-item{background:inherit;border:solid transparent;border-width:0 0 2px;box-sizing:border-box;color:var(--color-neutral-steel-800);cursor:pointer;font-family:var(--copytext-font-family-bold);font-size:var(--tabs-font-size);letter-spacing:var(--letter-spacing-basic);line-height:24px;outline:2px solid transparent;outline-offset:2px;padding-bottom:4px;white-space:nowrap}.tab-item-badge{background-color:var(--color-brand-primary);border-radius:9999px;height:8px;margin-top:-3px;width:8px}.tab-item:hover:not(:disabled):not(.tab-item--active){border-color:var(--color-accent-clay-soft)}.tab-item:active:not(:disabled):not(.tab-item--active){color:var(--color-neutral-steel-800)}.tab-item:disabled{color:var(--color-neutral-steel-700);cursor:default;opacity:.4}.tab-item--active{border-color:var(--color-black);color:var(--color-black)}.tab-item--subtle{letter-spacing:0}.tab-item--uppercase{text-transform:uppercase}.tab-item--capitalize{text-transform:capitalize}.tab-item--not-main{border-color:var(--color-neutral-steel-300);border-style:solid;border-width:0 0 2px}.tab-item--not-main:hover:not(:disabled):not(.tab-item--active){border-color:var(--color-accent-clay-soft)}.tab-item--not-main:active:not(:disabled):not(.tab-item--active){background-color:var(--color-neutral-steel-100);color:var(--color-neutral-steel-700)}.tab-item--not-main:disabled{color:var(--color-neutral-steel-700);cursor:default;opacity:.4}.tab-item--not-main.tab-item--active{border-color:var(--color-black);color:var(--color-black)}.static{position:static}", b = d, h = class {
  constructor(t) {
    l(this, t), this.itemActivation = s(this, "lhItemActivation", 7), this.handleActivation = () => {
      this.itemActivation.emit(this.itemId);
    }, this.label = "", this.active = !1, this.disabled = !1, this.subitems = void 0, this.subitemsAreCollapsed = !0, this.itemId = this.getItemId(), this.show = !0, this.subtle = null, this.capitalize = !0, this.badge = !1, this.ariaLabelState = "";
  }
  activeWatcher(t, e) {
    t && !e && this.itemActivation.emit(this.itemId);
  }
  /**
   * First, this methods tries to fetch the index of itself inside patternlib-tabs children.
   * If this does not work, a random id is generated.
   * @returns the calculated item id
   */
  getItemId() {
    var t;
    const e = (t = this.hostElement) === null || t === void 0 ? void 0 : t.parentElement, a = e == null ? void 0 : e.children;
    if (a != null) {
      for (let i = 0; i < a.length; i++)
        if (a[i] === this.hostElement)
          return i;
    }
    throw new Error("<patternlib-tabs-item /> should only be used inside <patternlib-tabs />");
  }
  componentWillLoad() {
    this.ariaLabelState = this.label, this.active && this.itemActivation.emit(this.itemId);
  }
  componentDidLoad() {
    this.ariaLabelState === "" && (this.ariaLabelState = this.getSlotTextContent());
  }
  getSlotTextContent() {
    let t = "";
    const e = this.hostElement.shadowRoot.querySelector("slot"), a = e == null ? void 0 : e.assignedNodes();
    return a == null || a.forEach((i) => {
      var r;
      t === "" && i.nodeType === Node.TEXT_NODE && (t = (r = i.textContent) === null || r === void 0 ? void 0 : r.trim());
    }), t;
  }
  render() {
    var t, e;
    if (!this.show)
      return;
    const a = this.hostElement.parentElement, i = (t = this.subtle) !== null && t !== void 0 ? t : a.subtle;
    return o(n, null, o("div", { class: "tab" }, o("button", { role: "tab", "aria-label": this.ariaLabelState, "aria-selected": this.active ? "true" : "false", onClick: this.handleActivation, class: {
      "tab-item": !0,
      "tab-item--active": this.active,
      "tab-item--subtle": i,
      "tab-item--uppercase": !i,
      "tab-item--capitalize": i && this.capitalize,
      "tab-item--not-main": ((e = this.hostElement) === null || e === void 0 ? void 0 : e.parentElement.parentElement.nodeName) !== "PATTERNLIB-MAIN-NAVIGATION"
    }, disabled: this.disabled }, o("slot", null, this.label)), this.badge && o("div", { class: "tab-item-badge" })));
  }
  get hostElement() {
    return c(this);
  }
  static get watchers() {
    return {
      active: ["activeWatcher"]
    };
  }
};
h.style = b;
export {
  h as patternlib_tabs_item
};
